/* eslint-disable jsx-a11y/alt-text */
import { Row, Col, Card, CardBody, Button, Spinner } from "reactstrap";
import {
  target_group,
  product_category,
  style,
  price,
} from "../../static/brands_wholesalers_data";

// Severity ramp: the most frequently missing attribute reads as the most urgent.
const RANK_COLORS = ["#dc3545", "#fd7e14", "#ffc107", "#20c997"];

const ATTRIBUTE_META = {
  target_group: { label: "Target Group", icon: target_group[0]?.imageBlack },
  product_category: { label: "Product Category", icon: product_category[0]?.imageBlack },
  style: { label: "Style", icon: style[0]?.imageBlack },
  price: { label: "Price Range", icon: price[0]?.imageBlack },
};

const PartiallyIncompletedAttributes = ({
  attributes = [],
  total = 0,
  isLoading,
  onViewClick,
}) => {
  if (!isLoading && (!attributes || attributes.length === 0)) return null;

  return (
    <div className="mt-4">
      <div className="d-flex align-items-baseline justify-content-between flex-wrap mb-1">
        <h4 className="mb-0 fw-bold" style={{ fontSize: "20px" }}>
          Partially Incompleted Attributes
        </h4>
      </div>
      <p className="small text-muted mb-3">
        Partially Incompleted Attributes from the partially incompleted profiles.
      </p>

      <Row className="g-3">
        {attributes.map((item, index) => {
          const meta = ATTRIBUTE_META[item?.attribute] || {
            label: item?.attribute,
          };
          const color = RANK_COLORS[index] || RANK_COLORS[RANK_COLORS.length - 1];
          const percentage = Number(item?.percentage) || 0;

          return (
            <Col sm={6} md={3} key={item?.attribute || index}>
              <Card
                className="border-0 shadow h-100"
                style={{ borderTop: `4px solid ${color}`, overflow: "hidden" }}
              >
                <CardBody className="px-3 py-3 d-flex flex-column justify-content-center">
                  <div className="d-flex align-items-start justify-content-between mb-2">
                    <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                      {meta.icon && <img src={meta.icon} width={32} height={33} />}
                      <h4 className="small text-muted mb-0">{meta.label}</h4>
                    </div>
                    <span
                      className="fw-bold"
                      style={{
                        fontSize: "12px",
                        color,
                        backgroundColor: `${color}1a`,
                        borderRadius: "40px",
                        padding: "2px 10px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      #{index + 1}
                    </span>
                  </div>

                  <div className="d-flex align-items-baseline" style={{ gap: "8px" }}>
                    <h1 className="mb-0 fw-bold">
                      {isLoading ? (
                        <Spinner
                          color="primary"
                          style={{ width: "2rem", height: "2rem" }}
                        />
                      ) : (
                        (item?.count || 0).toLocaleString()
                      )}
                    </h1>
                    {!isLoading && (
                      <span className="small fw-bold" style={{ color }}>
                        {percentage}%
                      </span>
                    )}
                  </div>

                  <div
                    className="mt-2"
                    style={{
                      height: "6px",
                      borderRadius: "40px",
                      backgroundColor: "#e9ecef",
                      overflow: "hidden",
                    }}
                    title={`${percentage}% of partially incompleted profiles are missing ${meta.label}`}
                  >
                    <div
                      style={{
                        width: `${isLoading ? 0 : Math.min(percentage, 100)}%`,
                        height: "100%",
                        backgroundColor: color,
                        transition: "width 0.4s ease",
                      }}
                    />
                  </div>

                  {/* <div className="d-flex justify-content-end pt-3 mt-auto">
                    <Button
                      color="primary"
                      onClick={() => onViewClick(item?.attribute)}
                      style={{ borderRadius: "40px" }}
                    >
                      View Details
                    </Button>
                  </div> */}
                </CardBody>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default PartiallyIncompletedAttributes;
